export default __webpack_public_path__ + "static/media/seva-assets2.bb056224.png";